import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { transactionValueSchema } from "@repo/core/helpers/zod.schemas";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";

export const NewTransactionValueController = () => {
  // Hooks
  const { navigateToNext, navigateBack, currentRouteConfig } =
    useNewTransactionFlow();
  const { replace } = useNavigation();

  const { isMobile } = useDimensions();

  // Store
  const {
    setTransactionValue,
    setDiscountedTransactionValue,
    selectedProduct,
    transactionValue,
    resetNewTransaction
  } = useNewTransactionStore();

  // Form
  const { control, handleSubmit, reset } = useForm({
    resolver: zodResolver(transactionValueSchema),
    values: {
      purchaseValue: transactionValue.toString()
    }
  });

  // Navigation Handlers

  const handleSubmitValue = handleSubmit((formData) => {
    setTransactionValue(Number(formData.purchaseValue));
    setDiscountedTransactionValue(Number(formData.purchaseValue));
    navigateToNext();
  });

  const handleBack = () => {
    resetNewTransaction();
    reset();
    navigateBack();
  };

  const handleOnCancel = () => {
    resetNewTransaction();
    reset();
    replace(ROUTES.sales);
  };

  return {
    // Layout
    isMobile,

    // Form
    control,

    // Data
    selectedProduct,
    title: currentRouteConfig.title,

    // Handlers
    handleBack,
    handleOnSubmitForm: handleSubmitValue,
    handleOnCancel
  };
};
